export default __webpack_public_path__ + "static/media/1_slide.0596d909.png";